import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Legal = () => {
  const { t } = useLanguage();
  const theme = useTheme();

  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
        <Header />
        <Box>
            <Container maxWidth="lg">
                <br/>
                <Typography variant="h1">Disclaimer</Typography>
                <Typography variant="body1">
                {t('legal.disclaimer')}
                </Typography>
            </Container>
        </Box>
        <Footer />
    </Box>
  );
};

export default Legal;